import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../Wrapper/Wrapper';

const CurrentPrice = ({ formattedCurrentPrice }) => (
  <Wrapper data-cy="single-product-price">{formattedCurrentPrice}</Wrapper>
);

CurrentPrice.propTypes = {
  formattedCurrentPrice: PropTypes.string.isRequired
};

export default CurrentPrice;
